// Shown to roles that cannot change an account's entity for a reason other than
// view-only. The endpoint behind the Entity dropdown allows admins/accountants
// or the connection owner; the frontend approximates that by exempting
// unassigned accounts (entityId === null), so a member sees a disabled control
// and this explanation only once an entity is set. View-only keeps a live
// control and the click answers.
export const ENTITY_CHANGE_RESTRICTION_TOOLTIP =
    "You don't have permission to change this account's entity";
